import React from 'react';

import PageLayout from '@/components/layout/PageLayout';
import { Card } from '@/components/ui/cards';
import { CreateShiftDescriptionForm, ShiftWeeklyDistributionGrid } from '@/components/features/shift';
import { useShiftCreate } from '@/hooks/shift/useShiftCreate';
import { useShiftWeeklyDistribution } from '@/hooks/shift/useShiftWeeklyDistribution';
import { useTranslation } from '@/i18n';


export const ShiftCreate: React.FC = () => {
  const { t: translate } = useTranslation('schedule');
  const {
    formSubset,
    isLoadingCatalogs,
    workingDayTypeOptions,
    workingDayOptions,
    selectedWorkingDay,
    isDistributedCyclesType,
    isExceptionalType,
    isStaticType,
    weeksCountEditable,
    ordinaryHours,
    isGridVisible,
    handleCancel,
    confirmNavigation,
  } = useShiftCreate();

  const descriptionValues = formSubset.watch();

  const weeklyDistribution = useShiftWeeklyDistribution({
    descriptionValues,
    selectedWorkingDay,
    ordinaryHours,
    confirmNavigation,
  });

  return (
    // `hideCard`: la Descripción y la Distribución de jornada son dos tarjetas
    // independientes (según diseño), en lugar de una sola tarjeta de PageLayout
    // conteniendo ambas secciones.
    <PageLayout
      isLoading={isLoadingCatalogs}
      dynamicTitle={translate('shift.create.title')}
      hideCard
    >
      <div data-testid="shift-create-page">
        {/* `padding=""` neutraliza el padding inline por defecto de Card (8px), que
            de lo contrario gana sobre las clases de Tailwind (mismo patrón que PageLayout). */}
        <Card padding="" className="p-6 md:p-8">
          <CreateShiftDescriptionForm
            form={formSubset}
            workingDayTypeOptions={workingDayTypeOptions}
            workingDayOptions={workingDayOptions}
            isDistributedCyclesType={isDistributedCyclesType}
            isExceptionalType={isExceptionalType}
            isStaticType={isStaticType}
            weeksCountEditable={weeksCountEditable}
            ordinaryHours={ordinaryHours}
          />
        </Card>

        {isGridVisible && (
          <ShiftWeeklyDistributionGrid
            {...weeklyDistribution}
            onCancel={handleCancel}
          />
        )}
      </div>
    </PageLayout>
  );
};

export default ShiftCreate;
